exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.app-wrapper[data-v-538a07c8]{position:relative;height:100%;width:100%\n}\n.app-wrapper[data-v-538a07c8]:after{content:\"\";display:table;clear:both\n}\n", "", {"version":3,"sources":["/var/jenkins_home/workspace/pro-maibenben-mall-admin-front/src/views/layout/Layout.vue"],"names":[],"mappings":";AACA,8BAA8B,kBAAkB,YAAY,UAAU;CACrE;AACD,oCAAoC,WAAW,cAAc,UAAU;CACtE","file":"Layout.vue","sourcesContent":["\n.app-wrapper[data-v-538a07c8]{position:relative;height:100%;width:100%\n}\n.app-wrapper[data-v-538a07c8]:after{content:\"\";display:table;clear:both\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-538a07c8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/Layout.vue
// module id = 0h6e
// module chunks = 65